import {Collection, Model} from 'backbone';

export default Collection.extend({
    comparator: 'name',
    model: Model.extend({
        idAttribute: 'uuid',
        blacklist: ['id'],
        initialize(data) {
            if (data.subsections) {
                data = Object.assign(
                    {
                        subsections: new Collection(data.subsections, {
                            comparator: 'name',
                            model: this.constructor,
                        }),
                    },
                    data,
                );
            }

            this.set(data);
        },
    }),
});
